import { render, staticRenderFns } from "./noticeboard.vue?vue&type=template&id=ebe5d776&scoped=true"
import script from "./noticeboard.vue?vue&type=script&lang=js"
export * from "./noticeboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe5d776",
  null
  
)

export default component.exports